import React, { memo } from 'react';
import { useTranslation } from 'i18n';
import { nameValueParser, nameValueTransformer, stringValueFormatter } from './utils';
import FilterSelectHandler from './FilterSelectHandler';

export interface IOngoingOpportunityFilterProps {
  disabled?: boolean;
}

const items = ['false', 'true'];

const OngoingOpportunityFilter: React.FC<React.PropsWithChildren<IOngoingOpportunityFilterProps>> = (props) => {
  const { disabled } = props;
  const [t] = useTranslation();

  return (
    <FilterSelectHandler
      name="ongoing_opportunities"
      placeholder={t<string>('common:filter.ongoing_opportunities')}
      disabled={disabled}
      items={items}
      labelFormatter={(item) => t(`common:general.ongoing_opportunities_${item}`)}
      valueFormatter={stringValueFormatter}
      valueTransformer={nameValueTransformer}
      valueParser={nameValueParser}
      clearValueParser={(queryParams) => ({
        ...queryParams,
        ongoing_opportunities: undefined,
      })}
    />
  );
};

export default memo(OngoingOpportunityFilter);
